<template>
  <div>
    <div class="kanban-board" v-if="kanbanData?.length">
      <draggable
        v-model="stages"
        :group="{ name: 'stages', pull: ['stages'], put: ['stages'] }"
        direction="horizontal"
        class="kanban-container"
        :animation="200"
        @end="onStageReorder"
      >
        <div v-for="stage in kanbanData" :key="stage.id" class="kanban-column">
          <div
            class="kanban-header d-flex justify-content-between align-items-center mb-2"
          >
            <h5 class="kanban-title mb-0">{{ stage.title }}</h5>
            <b-dropdown size="sm" variant="light" right no-caret>
              <template v-slot:button-content>
                <span class="d-inline-flex align-items-center">
                  <i class="fa fa-cog mr-1"></i>
                  <span>Setting</span>
                </span>
              </template>
              <b-dropdown-item @click="$emit('onDenied', stage.id)">
                Set Denied Process
              </b-dropdown-item>
              <b-dropdown-item @click="$emit('onSpalProcess', stage.id)">
                Set SPAL Process
              </b-dropdown-item>
              <b-dropdown-item @click="$emit('onRunningProcess', stage.id)">
                Set Running Process
              </b-dropdown-item>
              <b-dropdown-item @click="$emit('onEndStage', stage.id)">
                Set End Stage
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="openUpdateStage(stage)">
                Update Stage
              </b-dropdown-item>
              <b-dropdown-item
                @click="$emit('onRemoveStage', stage)"
                class="text-danger"
              >
                Delete Stage
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <b-alert
            show
            variant="primary"
            class="d-dflex align-items-center p-2"
            v-if="getStageStatus(stage)"
          >
            <i class="fas fa-exclamation-circle mr-2"></i>
            This Stage is
            <strong class="ml-2">{{ getStageStatus(stage) }}</strong>
          </b-alert>
          <draggable
            v-model="stage.tasks"
            :group="{ name: 'tasks', pull: true, put: true }"
            :animation="150"
            ghost-class="ghost-card"
            class="kanban-tasks-container"
            @end="onTaskMove(stage)"
            @add="onTaskAdded(stage, $event)"
          >
            <div
              v-for="task in stage.tasks"
              :key="task?.id"
              class="kanban-card p-3"
            >
              {{ task.title }}
              <!-- <div class="pb-2 text-center" style="cursor: move">
                <i class="fas fa-grip-lines"></i>
              </div> -->
              <div
                class="d-flex justify-content-between align-items-center w-100 mb-2"
              >
                <div class="text-black text-primary">
                  <strong>{{ task?.project ?? 'Shipment Planning' }}</strong>
                </div>
                <b-dropdown size="lg" variant="none" no-caret class="p-0">
                  <template v-slot:button-content>
                    <div class="">
                      <i class="fas fa-ellipsis-v text-primary"></i>
                    </div>
                  </template>
                  <b-dropdown-item
                    href="#"
                    variant="primary"
                    @click="$emit('openSlideFormAddPlan', 'PREVIEW', task?.id)"
                  >
                    <i class="fa fa-eye mr-2"></i>
                    Detail
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    variant="warning"
                    v-if="task?.is_pfa"
                    @click="$emit('openPfaSlide', task?.id)"
                  >
                    <i class="fa fa-info-circle mr-2"></i>
                    PFA
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    variant="success"
                    @click="$emit('openSlideSpalProcess', 'ADD', task?.id)"
                    v-if="task?.project_stage?.spal_process"
                  >
                    <i class="fa fa-info-circle mr-2"></i>
                    Spal Process
                  </b-dropdown-item>
                  <!-- <b-dropdown-divider
                    v-if="
                      approvalPermission(task?.user_approval) === true ||
                      (['System Checker'].includes(userProfileName) &&
                        Number(task?.count_approval) !==
                          Number(task?.many_approval))
                    "
                  ></b-dropdown-divider> -->
                  <b-dropdown-item
                    href="#"
                    variant="primary"
                    v-b-modal.project-approval
                  >
                    <!-- @click="projectId = task?.id"
                    v-if="
                      approvalPermission(task?.user_approval) === true ||
                      (['System Checker'].includes(userProfileName) &&
                        Number(task?.count_approval) !==
                          Number(task?.many_approval))
                    " -->
                    <i class="fa fa-check mr-2"></i>
                    Approval
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item
                    href="#"
                    variant="danger"
                    @click="$emit('onDeleteProjectContract', task)"
                  >
                    <i class="fa fa-trash mr-2"></i>
                    Delete
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div>
                <div class="d-flex">
                  Project Type :
                  <strong class="text-muted ml-2">
                    {{
                      task?.project_type === 'existing'
                        ? 'Existing'
                        : 'New Project'
                    }}
                  </strong>
                </div>
                <div class="d-flex">
                  Total Shipment :
                  <strong class="text-muted ml-2">
                    {{ task?.shipment }} SHIPMENT
                  </strong>
                </div>
                <div class="d-flex">
                  Capacity :
                  <strong class="text-muted ml-2">
                    {{ formatNumber(task?.volume) }} VOLUME
                  </strong>
                </div>
              </div>
              <div class="mt-4 d-flex align-items-center">
                Periode :
                <span class="text-sm text-dark ml-2">
                  <strong>
                    {{ moment(task?.periode_start).format('DD MMM YYYY') }}
                  </strong>
                  s/d
                  <strong>
                    {{ moment(task?.periode_end).format('DD MMM YYYY') }}
                  </strong>
                </span>
              </div>
              <small class="text-muted text-capitalize text-end">
                Created by:
                <strong class="text-primary">
                  {{ task?.project_log?.[0]?.name }}
                </strong>
              </small>
            </div>
            <div v-if="stage.tasks.length === 0" class="empty-drop-zone">
              Drop tasks here
            </div>
          </draggable>
        </div>
      </draggable>
      <div class="kanban-column" style="height: max-content">
        <div class="empty-drop-zone cursor-pointer" @click="showSidebar = true">
          <div class="d-flex flex-column justify-content-center">
            <i class="fa fa-plus text-center mr-2" style="font-size: 24px"></i>
            <strong>Add New Stage</strong>
          </div>
        </div>
      </div>
    </div>
    <CustomSidebar
      v-model="showSidebar"
      :title="selectedStage ? 'Edit Project Stage' : 'New Project Stage'"
      size="40%"
    >
      <FormAddProjectStage
        :kanbanData="kanbanData"
        :selectedData="selectedStage"
        v-if="showSidebar"
        @close="showSidebar = false"
        @refetch="$emit('refetch')"
      />
    </CustomSidebar>

    <CustomSidebar
      v-model="showSidebarRunning"
      title="New Running Shipment"
      size="50%"
      noCloseOnBackdrop
      noCloseOnEsc
    >
      <FormAddRunningShipment
        :kanbanData="kanbanData"
        :selected-task="selectedTask"
        v-if="showSidebarRunning"
        @close="handleRunningClose"
        @refetch="$emit('refetch')"
        @submit="submitFormAddRunningShipment"
      />
    </CustomSidebar>
  </div>
</template>

<script scoped>
// @ts-nocheck
import draggable from 'vuedraggable'
import moment from 'moment'
import CustomSidebar from '../global/CustomSidebar.vue'
import FormAddProjectStage from '@/src/views/Busdev/Dashboard/FormAddProjectStage.vue'
import FormAddRunningShipment from '@/src/views/Busdev/Dashboard/FormAddRunningShipment.vue'
import { busdevActions } from '@/src/Utils/helper'

export default {
  name: 'KanbanNew',
  props: {
    kanbanData: {
      type: Array,
      default: [],
    },
    approvalPermission: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    draggable,
    CustomSidebar,
    FormAddProjectStage,
    FormAddRunningShipment,
  },
  watch: {
    showSidebarRunning: {
      handler(newValue, oldValue) {
        if (
          newValue !== null &&
          newValue !== undefined &&
          newValue !== oldValue
        ) {
          if (newValue === false) {
            this.handleRunningClose()
          }
        }
      },
    },
  },
  data() {
    return {
      showSidebar: false,
      showSidebarRunning: false,
      // expose moment to template usage
      moment,
      selectedTask: null,
      selectedStage: null,
      // Track a pending move when dropping into Running stage
      pendingMove: null,
      fromStageId: null,
      toStageId: null,
    }
  },
  computed: {
    // Proxy stages to kanbanData to satisfy v-model binding on outer draggable
    stages: {
      get() {
        return this.kanbanData
      },
      set(val) {
        // Keep internal list in sync for rendering order
        // and emit to parent so it can persist
        // Note: parent owns the canonical data; we inform it of new order
        this.$emit('reorderStages', val)
      },
    },
  },
  methods: {
    ...busdevActions,
    formatNumber(value) {
      if (!value) return '0'
      return new Intl.NumberFormat('id-ID').format(value)
    },
    // Determine if moving a task to the target stage is allowed based on approvals
    canMoveToStage() {
      try {
        const prevStage = this.kanbanData.find((s) => s.id === this.fromStageId)
        const toStage = this.kanbanData.find((s) => s.id === this.toStageId)

        if (prevStage?.spal_process) {
          if (this.selectedTask && this.selectedTask.spal_process?.length === 0 && this.selectedTask?.contract_type?.is_spal === 1) {
            this.$swal({
              icon: 'warning',
              title: 'Butuh Spal',
              text: 'Task ini perlu Spal Process untuk melanjutkan.',
              confirmButtonText: 'OK',
            })
            if (prevStage && toStage) {
              const idxInTo = (toStage.tasks || []).findIndex(
                (t) => t?.id === this.selectedTask?.id
              )
              if (idxInTo !== -1) {
                const [task] = toStage.tasks.splice(idxInTo, 1)
                const insertIndex = (prevStage.tasks || []).length
                prevStage.tasks.splice(insertIndex, 0, task)
              }
            }
            return
          }
        }

        if (toStage?.order >= 3 && this.selectedTask) {
          const { count_approval = 0, user_approval = [] } = this.selectedTask
          if (count_approval !== user_approval.length) {
            this.$swal({
              icon: 'warning',
              title: 'Butuh Approval',
              text: 'Task ini perlu disetujui terlebih dahulu sebelum dipindahkan ke stage ini.',
              confirmButtonText: 'OK',
            })
            if (prevStage && toStage) {
              const idxInTo = (toStage.tasks || []).findIndex(
                (t) => t?.id === this.selectedTask?.id
              )
              if (idxInTo !== -1) {
                const [task] = toStage.tasks.splice(idxInTo, 1)
                const insertIndex = (prevStage.tasks || []).length
                prevStage.tasks.splice(insertIndex, 0, task)
              }
            }
            return
          }
        }
      } catch (e) {
        return e
      }
    },
    // Triggered when a stage column is dropped after drag
    onStageReorder(evt) {
      try {
        const { oldIndex, newIndex } = evt || {}
        if (
          oldIndex === undefined ||
          newIndex === undefined ||
          oldIndex === null ||
          newIndex === null ||
          oldIndex === newIndex
        ) {
          return
        }

        // Perform precise move locally on a copy to compute the new order
        const next = Array.isArray(this.kanbanData) ? [...this.kanbanData] : []
        const [moved] = next.splice(oldIndex, 1)
        next.splice(newIndex, 0, moved)

        const ordered = next.map((s, index) => ({ id: s.id, order: index }))

        // Emit for parent to sync UI/state
        this.$emit('reorderStages', ordered)
      } catch (e) {
        // no-op to avoid breaking UX
      }
    },
    onTaskMove(stage) {
      // Fired after a drag within or between lists completes
      this.fromStageId = stage?.id || null
      try {
        this.canMoveToStage()
        // Above heuristic not reliable; use from/to ids tracked by onTaskAdded
      } catch (_) {}
      this.$emit('onCardMove')
    },
    onTaskAdded(stage, evt) {
      try {
        this.toStageId = stage?.id || null
        if (stage && stage.is_running) {
          this.selectedTask =
            stage.tasks[stage.tasks.length === 1 ? 0 : evt?.newIndex]
          const { count_approval = 0, user_approval = [] } = this.selectedTask
          if (count_approval === user_approval.length) {
            this.showSidebarRunning = true
          }
        }
      } catch (e) {
        // no-op
      }
      this.$emit('onCardMove')
    },
    openUpdateStage(stage) {
      try {
        this.selectedStage = stage
        this.showSidebar = true
      } catch (e) {
        this.showSidebar = true
      }
    },
    getStageStatus(stage) {
      if (stage.is_deny) {
        return 'Denied Process'
      } else if (stage.is_running) {
        return 'Running Process'
      } else if (stage.is_end_stage) {
        return 'End Stage Process'
      } else if (stage.spal_process) {
        return 'SPAL Process'
      }
      return ''
    },
    handleRunningClose() {
      const prevStage = this.kanbanData.find((s) => s.id === this.fromStageId)
      const toStage = this.kanbanData.find((s) => s.id === this.toStageId)
      if (prevStage && toStage) {
        const idxInTo = (toStage.tasks || []).findIndex(
          (t) => t?.id === this.selectedTask?.id
        )
        if (idxInTo !== -1) {
          const [task] = toStage.tasks.splice(idxInTo, 1)
          const insertIndex = (prevStage.tasks || []).length
          prevStage.tasks.splice(insertIndex, 0, task)
        }
      }
      // Persist reverted state if parent didn't handle
      this.saveMovedState()
      // Close and clear state
      this.showSidebarRunning = false
      this.selectedTask = null
      this.pendingMove = null
      this.$emit('refetch')
    },
    async submitFormAddRunningShipment(data) {
      try {
        await this.updateProjectContract({
          data: {
            ...data.data,
            mode: data.mode,
          },
          id: data.data.project_id,
        })
        this.showSidebarRunning = false
        // Clear pending move on success (we keep the card in the new stage)
        this.pendingMove = null
        this.$emit('refetch')
      } catch (e) {
        return e
      }
    },
    // Helper to persist moved cards order
    async saveMovedState() {
      try {
        const readyToSave = []
        this.kanbanData.forEach((val) => {
          if ((val.tasks || []).length > 0) {
            readyToSave.push({
              detail_project_stage_id: val.id,
              tasks: val.tasks.map((obj) => ({ id: obj.id })),
            })
          }
        })
        if (readyToSave.length > 0 && this.saveMovedProjects) {
          await this.saveMovedProjects({ data: readyToSave })
        }
      } catch (e) {
        // swallow to avoid UX disruption; parent flow may handle errors
        return e
      }
    },
  },
}
</script>

<style scoped>
.kanban-board {
  display: flex;
  overflow-x: auto;
  padding: 20px;
}

.kanban-container {
  display: flex;
  flex-direction: row;
}

.kanban-column {
  background: #f8f9fa;
  border-radius: 10px;
  min-width: 340px;
  padding: 10px;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
}

.kanban-title {
  color: #007bff;
  font-weight: 600;
  margin-bottom: 10px;
}

.kanban-tasks-container {
  min-height: 100px;
  flex: 1;
}

.empty-drop-zone {
  min-height: 80px;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-style: italic;
  margin: 8px 0;
  transition: all 0.2s;
}

.empty-drop-zone:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
  color: #007bff;
}

.kanban-card {
  background: white;
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: all 0.2s;
}

.kanban-card:hover {
  transform: scale(1.03);
}

.ghost-card {
  background: #e3f2fd;
  border: 2px dashed #90caf9;
  opacity: 0.8;
}
</style>
